import React from "react";
import {SearchResultTableWithUpdateUI} from "../Common/SearchResultTableWithUpdateUI";
import {View} from "../GenGenPlate/Enum";
import {gppApiConsts} from "./GppApiConsts";
import {GppTableDataApi} from "./GppTableDataApi";
import {PlasmidForm} from "./PlasmidForm";
import { ConsoleLogger } from "aws-amplify/utils";

interface PlasmidSearchResultTableState {}

interface PlasmidSearchResultTableProps {
    keywords: string
    comparator: string
    refreshToken: string
    view: View
}

const logger = new ConsoleLogger("PlasmidSearchResultTable.tsx")

export class PlasmidSearchResultTable extends React.Component<PlasmidSearchResultTableProps, PlasmidSearchResultTableState> {
    static defaultProps = {
        refreshToken: "",
        keywords: "",
    }

    render() {
        logger.info("PlasmidSearchResultTable comparator ", this.props.comparator)
        return <SearchResultTableWithUpdateUI
            refreshToken={this.props.refreshToken}
            databaseName={gppApiConsts.DATABASE_NAME}
            tableName={"plasmid"}
            keywords={this.props.keywords}
            columns={""}
            operator={this.props.comparator}
            keyField={"id"}
            title={this.props.view === View.Update ? "" : "Plasmid"}
            modalForm={PlasmidForm}
            legends={<></>}
            rowClasses={row => "table-light"}
            columnsHidden={[]}
            columnsDisplayInOrder={[
                "owner", "id", "name", "guideASequence", "guideBSequence", "backbone", "antibioticSelection", "elutedIn",
                "originOfInsert", "project", "stockType", "stockCreationDate", "lastModified", "additionalNote"
            ]}
            view={this.props.view}
            enableFilter={this.props.view === View.Update}
            searchTable={GppTableDataApi.searchTable}
        />
    }
}